import { getUrl, postUrl } from '@/apiCalls/fetch';
import { selectIsNZ } from '@/context/display';
import { store } from '@/context/store';

import { ILookupAbnOrAcn, ILookupAbnOrAcnResponse } from '../commonTypes';

export async function lookupAbn(
    abn: string
): Promise<ILookupAbnOrAcn | undefined> {
    const state = store.getState();
    const isNZ = selectIsNZ(state);
    if (isNZ) {
        const response = await postUrl<ILookupAbnOrAcn>('/api/abn/detail', {
            country: 'NZ',
            abn,
        });
        return response;
    }

    const url = `/api/abnLookup/abn/${abn}`;
    const response = await getUrl<ILookupAbnOrAcnResponse>(url);

    return response.data;
}
